/* eslint-disable react/forbid-prop-types */
import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { Card, CardHeader, CardBody, Col } from 'reactstrap';

// Local Deps
import { Button, Modal } from 'antd';
import { SubsContext } from '../../components/Billsby/SubscriptionInfo';

import history from '../../config/history';
import './SolicitationDetail.scss';
import msgs from '../../config/messages';
import { isFeatureEnabled } from '../../config/featureFlags';
// Components
import Loading from '../../components/Loading';
import SolicitationDetailHOC from './SolicitationDetailHOC';
import InformationGrid from '../../components/grids/InformationGrid';
import DrawingsGrid from '../../components/grids/DrawingsGrid';
import RecentSolicitationsGrid from '../../components/grids/RecentSolicitations';
import ProcurementHistoryGrid from '../../components/grids/ProcurementHistoryGrid';
import SendRfq from '../../components/Modals/SendRfq';

import WSDCgrid from '../../components/grids/WSDCGrid';
import SegCgrid from '../../components/grids/RefNumbers';
import Subscription from '../../components/Subscription/Subscription';
import PackagingInfoGrid from '../../components/grids/PackagingInfoGrid/PackagingInfoGrid';
import TechInfoGrid from '../../components/grids/TechInfoGrid';
import ItemDescInfoGrid from '../../components/grids/ItemDescInfoGrid/ItemDescInfoGrid';
import AceButton from './AceButton';

class SolicitationDetail extends PureComponent {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    id: PropTypes.string.isRequired,
    castingType: PropTypes.string.isRequired,
    amc: PropTypes.string.isRequired,
    purchaseRequest: PropTypes.shape({
      nsnNumber: PropTypes.string.isRequired,
      fscCode: PropTypes.string.isRequired,
      purchaseRequestNumber: PropTypes.string.isRequired,
    }).isRequired,
    issueDate: PropTypes.string.isRequired,
    closes: PropTypes.string,
    returnDate: PropTypes.string,
    srva: PropTypes.string.isRequired,
    procurementHistory: PropTypes.instanceOf(Array).isRequired,
    drawings: PropTypes.instanceOf(Array).isRequired,
    recentSolicitations: PropTypes.instanceOf(Array).isRequired,
    techInfo: PropTypes.string.isRequired,
    itemDescInfo: PropTypes.string.isRequired,
    nomenclature: PropTypes.string.isRequired,
    packagingInfo: PropTypes.string.isRequired,
    showDownload: PropTypes.bool.isRequired,
    showDownloadDrawingsModal: PropTypes.bool.isRequired,
    openDownloadDrawingsModal: PropTypes.func.isRequired,
    handleDownloadDrawingsCancel: PropTypes.func.isRequired,
    handleDownloadDrawingsOk: PropTypes.func.isRequired,
    downloadSelected: PropTypes.func.isRequired,
    setAside: PropTypes.string.isRequired,
    um: PropTypes.string.isRequired,
    wsdcs: PropTypes.array.isRequired,
    refNbrs: PropTypes.array.isRequired,
    process: PropTypes.string.isRequired,
    materialsMethods: PropTypes.any.isRequired,
    closeRfqModal: PropTypes.func.isRequired,
    closeProcGroupModal: PropTypes.func.isRequired,
    modalRfqOpen: PropTypes.bool.isRequired,
    modalProcGroupVisible: PropTypes.bool.isRequired,
    handleDIBBSQuote: PropTypes.func.isRequired,
    openRfqModal: PropTypes.func.isRequired,
    rfqInput: PropTypes.instanceOf(Object).isRequired,
    estValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    solicitationTab: PropTypes.arrayOf(
      PropTypes.shape({
        standardCost: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      })
    ),
    itemDescription: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.arrayOf(PropTypes.object),
    ]), // From universal details query - contains EBS Material fields
    itemDetails: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.arrayOf(PropTypes.object),
    ]),
    ebsPackaging: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.arrayOf(PropTypes.object),
    ]),
  };

  static defaultProps = {
    estValue: null,
    solicitationTab: [],
    itemDescription: null,
    itemDetails: [],
    ebsPackaging: [],
    closes: null,
    returnDate: null,
  };

  render() {
    const {
      isLoading,
      id,
      castingType = '',
      amc = '',
      issueDate,
      closes,
      returnDate,
      purchaseRequest,
      srva,
      procurementHistory,
      drawings,
      recentSolicitations,
      techInfo,
      packagingInfo,
      itemDescInfo,
      nomenclature,
      showDownloadDrawingsModal,
      showDownload,
      openDownloadDrawingsModal,
      handleDownloadDrawingsCancel,
      handleDownloadDrawingsOk,
      setAside,
      downloadSelected,
      um,
      process,
      materialsMethods,
      wsdcs,
      refNbrs,
      auth,
      closeRfqModal,
      closeProcGroupModal,
      modalRfqOpen,
      modalProcGroupVisible,
      handleDIBBSQuote,
      openRfqModal,
      estValue,
      solicitationTab,
      itemDetails = [],
      ebsPackaging = [],
      itemDescription = null, // From universal details query (contains EBS Material fields)
    } = this.props;

    const AceItems = {
      id,
      solicitationNum: id, // Use id as solicitationNum
      castingType,
      amc,
      issueDate,
      closes,
      returnDate,
      delivery: issueDate, // Use issueDate as delivery
      purchaseRequest,
      srva,
      procurementHistory,
      drawings,
      recentSolicitations, // Contains NAICS from EBS_PRCH_REQ
      techInfo,
      packagingInfo,
      itemDescInfo, // String description from solicitation query
      itemDescription, // From universal details query - contains EBS Material fields from EBS_MATERIAL table
      itemDetails, // Contains HMIC_0865 from NSN_MASTER (if available)
      ebsPackaging, // Contains PLACE_INSPN_CD from EBS_PACKAGING (if available)
      nomenclature,
      setAside,
      um,
      estValue, // Add estValue from props
      solicitationTab, // Add solicitationTab from props
      process,
      materialsMethods,
      wsdcs,
      refNbrs,
    }

    const Items = [
      {
        id,
        castingType,
        issueDate,
        purchaseRequest,
        nomenclature,
        drawings,
        setAside,
        srva,
        um,
        process,
        materialsMethods,
        auth,
      },
    ];
    return (
      // <Container style={{ width: '85vw', maxWidth: 'none' }}>
      <React.Fragment>
        <Subscription service="Solicitation Details" level="ICON Plus">
          <Helmet>
            <meta charSet="utf-8" />
            <title>NFFS ICON - Solicitation Details Page</title>
          </Helmet>
          <Col lg="auto">
            <div className="nf-solicitation-detail">
              {/* <!-- HEADER --> */}
              <h4 className="nf-solicitation-detail__header">
                {msgs.SolicitationDetail.header}
              </h4>
              {/* <div className="nf-solicitation-detail__subheader">
              {msgs.SolicitationDetail.subheader(purchaseRequest.nsnPart)}
            </div> */}
              {/* LOADING */}
              {isLoading && <Loading text="Please wait while the data loads" />}
              {/* <!-- DETAILS TABLE --> */}
              {!isLoading && (
                <React.Fragment> <div>
                  <span style={{
                    'margin-right': '10px'
                  }} id='dibbsQuote' >
                    <Button
                      onClick={e => {
                        handleDIBBSQuote(id);
                        e.preventDefault();
                      }}
                      type="primary"
                      style={{
                        display: 'none',
                        background: '#ff7c52',
                        border: '#ff7c52',
                        borderRadius: '6px',
                      }}
                    >
                      DIBBS Quote
                    </Button>
                  </span>

                  {/* <div className='nf-u-details__grid'> */}
                  <div className='sendRFQ2'>
                    {isFeatureEnabled('ENABLE_ACE') && (
                      <SubsContext.Consumer>
                        {({ subscriptionLevel }) => (
                          subscriptionLevel === 'ICON Pro' && (
                            <Button
                              onClick={() => window.open('https://valorgroup-securesignon--iconsandb.sandbox.my.site.com/ACE/login?ec=302&startURL=%2FACE%2F', '_blank')}
                              type="primary"
                              style={{
                                background: '#ff7c52',
                                border: '#ff7c52',
                                color: '#ffffff',
                                borderRadius: '6px',
                                marginRight: '8px',
                              }}
                            >
                              Login To ACE
                            </Button>
                          )
                        )}
                      </SubsContext.Consumer>
                    )}
                    <AceButton
                      items={AceItems}
                      auth={auth} />
                    &nbsp;
                    <Button id="sndRFQ"
                      onClick={openRfqModal}
                      type="primary"
                      style={{
                        background: '#ff7c52',
                        border: '#ff7c52',
                        borderRadius: '6px',
                      }}
                    >
                      Send RFQ
                    </Button>
                  </div>
                  <div id="mybutton2">
                    <Button
                      className="floating-back"
                      onClick={() => {
                        history.goBack();
                      }}
                    >
                      Go Back
                    </Button>
                  </div>
                  {/* </div> */}
                </div>
                  <Card className="nf-solicitation-detail__card">
                    <CardHeader className="nf-solicitation-detail__card-header">
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      >
                        <div>{msgs.SolicitationDetail.InfoTableHeader}</div>


                      </div>
                    </CardHeader>
                    <InformationGrid items={Items} />
                  </Card>
                  {/* DRAWING TABLE */}
                  <Card className="nf-solicitation-detail__card">
                    <CardHeader className="nf-solicitation-detail__card-header">
                      {drawings.length === 0
                        ? `${msgs.SolicitationDetail.DrawingTableHeader
                        } - None Found`
                        : msgs.SolicitationDetail.DrawingTableHeader}
                      {showDownload && (
                        <Button
                          onClick={() => openDownloadDrawingsModal()}
                          type="primary"
                          block
                          style={{
                            color: '#fff',
                            width: '30vh',
                            'font-weight': 'bold',
                            display: 'inline',
                            'margin-left': '16px',
                          }}
                        >
                          Download Drawings
                        </Button>
                      )}
                    </CardHeader>
                    {drawings.length === 0 ? null : (
                      <DrawingsGrid
                        downloadSelected={downloadSelected}
                        drawings={drawings}
                      />
                    )}
                  </Card>
                  {/* RECENT SOLICITATIONS */}
                  <Card className="nf-solicitation-detail__card">
                    <CardHeader className="nf-solicitation-detail__card-header">
                      {recentSolicitations.length === 0
                        ? `${msgs.SolicitationDetail.RecentSolicitationHeader
                        }  - None Found`
                        : msgs.SolicitationDetail.RecentSolicitationHeader}
                    </CardHeader>
                    {recentSolicitations.length === 0 ? null : (
                      <RecentSolicitationsGrid
                        RecentSolicitations={recentSolicitations}
                        auth={auth}
                      />
                    )}
                  </Card>
                  {/* <!-- PROCUREMENT HISTORY GRID --> */}
                  <Card className="nf-solicitation-detail__card">
                    <CardHeader className="nf-solicitation-detail__card-header">
                      {procurementHistory.length === 0
                        ? `${msgs.SolicitationDetail.ProcHistHeader
                        }  - None Found`
                        : msgs.SolicitationDetail.ProcHistHeader}
                    </CardHeader>
                    {procurementHistory.length === 0 ? null : (
                      <ProcurementHistoryGrid procurements={procurementHistory} />
                    )}
                  </Card>
                  {/* TECHNICAL CHARACTERISTICS */}
                  <Card className="nf-solicitation-detail__card">
                    <CardHeader className="nf-solicitation-detail__card-header">
                      {techInfo
                        ? msgs.SolicitationDetail.TechnicalCharHeader
                        : `${msgs.SolicitationDetail.TechnicalCharHeader
                        } - None Found`}
                    </CardHeader>
                    {techInfo ? <CardBody>
                      <TechInfoGrid techInfoText={techInfo} />
                    </CardBody> : null}
                  </Card>
                  {/* ITEM DESCRIPTION */}
                  <Card className="nf-solicitation-detail__card">
                    <CardHeader className="nf-solicitation-detail__card-header">
                      {itemDescInfo
                        ? msgs.SolicitationDetail.DescriptionHeader
                        : `${msgs.SolicitationDetail.DescriptionHeader
                        } - None Found`}
                    </CardHeader>
                    {itemDescInfo ? (
                      <CardBody className="nf-solicitation-detail__card-body">
                        <ItemDescInfoGrid itemDescInfoText={itemDescInfo} />
                      </CardBody>
                    ) : null}
                  </Card>
                  {/* PACKAGING INFORMATION */}
                  <Card className="nf-solicitation-detail__card">
                    <CardHeader className="nf-solicitation-detail__card-header">
                      {packagingInfo
                        ? msgs.SolicitationDetail.PackingInfoHeader
                        : `${msgs.SolicitationDetail.PackingInfoHeader
                        } - None Found`}
                    </CardHeader>
                    {packagingInfo ? <CardBody>
                      <PackagingInfoGrid packagingInfoText={packagingInfo} />
                    </CardBody> : null}
                  </Card>
                  <Card className="nf-solicitation-detail__card">
                    {' '}
                    <CardHeader className="nf-solicitation-detail__card-header">
                      {refNbrs
                        ? 'Part Number Seg C'
                        : `${'Part Number Seg C'} - None Found`}
                    </CardHeader>
                    <SegCgrid data={refNbrs} />
                  </Card>

                  <Card className="nf-solicitation-detail__card">
                    {' '}
                    <CardHeader className="nf-solicitation-detail__card-header">
                      {wsdcs
                        ? 'Weapon Systems Designator Codes'
                        : `${'Weapon Systems Designator Codes'} - None Found`}
                    </CardHeader>
                    <WSDCgrid data={wsdcs} />
                  </Card>
                </React.Fragment>
              )}
            </div>
          </Col>
          <Modal
            title="Attention"
            visible={showDownloadDrawingsModal}
            onCancel={handleDownloadDrawingsCancel}
            footer={[
              <Button key="back" onClick={handleDownloadDrawingsCancel}>
                Cancel
              </Button>,
              <Button key="submit" type="primary" onClick={handleDownloadDrawingsOk}>
                Proceed
              </Button>,
            ]}
          >
            <p>
              {msgs.cfolders.drw_popup}
              <span className="nf-cfolders-bold">{msgs.cfolders.drw_popup1}</span>
              {msgs.cfolders.drw_popup2}
              <span className="nf-cfolders-bold">{msgs.cfolders.drw_popup3}</span>
              {msgs.cfolders.drw_popup4}
              <span className="nf-cfolders-bold">{msgs.cfolders.drw_popup5}</span>
              {msgs.cfolders.drw_popup6}
              <span className="nf-cfolders-bold">
                <a href="/help">{msgs.cfolders.drw_popup7}</a>
              </span>
              {msgs.cfolders.drw_popup8}
            </p>
          </Modal>
          <SendRfq
            auth={this.props.auth}
            rfqInput={this.props.rfqInput}
            closeRfqModal={closeRfqModal}
            closeProcGroupModal={closeProcGroupModal}
            modalRfqOpen={modalRfqOpen}
            modalProcGroupVisible={modalProcGroupVisible}
          />
        </Subscription>
      </React.Fragment>
    );
  }
}

export default SolicitationDetailHOC(SolicitationDetail);



// WEBPACK FOOTER //
// ./src/pages/SolicitationDetail/SolicitationDetail.jsx